import { useAuthMutation, useQueryClient } from 'queries/query';
import { getQueryKeys } from 'queries/query-key';
import { KEY } from './keys';
import { OrgMemberApi } from 'api';

function useUnassign(orgId: number) {
  const queryClient = useQueryClient();
  return useAuthMutation(
    ({ adminId, roleId }: { adminId: number; roleId: number }) =>
      OrgMemberApi.unassign(orgId, adminId, roleId),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: getQueryKeys([KEY]).all });
      },
    },
  );
}

export default useUnassign;
